import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import {
  LoadTimingMetaInfo,
  LoadTimingStatus,
  LoadTimingType,
} from "@faire/web/common/performance/userPerceivedLoadTiming/types";
import { trackFrontendToolingPerformanceBreakdownTiming } from "@faire/web-api/events/frontendTooling/timing/performanceBreakdown";

import { PerformanceBreakdown } from "../PerformanceBreakdown";

export const trackPerformanceBreakdownInUserPerceivedLoadTiming = ({
  name,
  loadType,
  status,
  timeOfLastRouteChange,
  breakdown,
  lastImageLoadTime,
  mainThreadQuietTime,
  upltEndTime,
}: {
  name: LoadTimingMetaInfo["name"];
  loadType: LoadTimingType | undefined;
  status: LoadTimingStatus;
  timeOfLastRouteChange: number;
  breakdown: PerformanceBreakdown;
  lastImageLoadTime: DOMHighResTimeStamp | undefined;
  mainThreadQuietTime: DOMHighResTimeStamp | undefined;
  upltEndTime: DOMHighResTimeStamp | undefined;
}) => {
  const {
    htmlStarted,
    dataFetched,
    mainJsExecuted,
    pageComponentMounted,
    pageComponentRenderedWithData,
    pageJsExecuted,
    readyToFetchData,
    readyToFetchPageJs,
  } = breakdown;

  const timeSinceLastRouteChange = (timestamp: DOMHighResTimeStamp): number => {
    // timeOfLastRouteChange is 0 for direct loads
    // for route change, we want to report the time since the last in-app navigation
    return Math.round(timestamp - timeOfLastRouteChange);
  };

  const format = (timestamp: DOMHighResTimeStamp | undefined): string => {
    if (timestamp === undefined) {
      return "NULL"; // so that we can query for this in SQL to troubleshoot
    }

    return `${timeSinceLastRouteChange(timestamp)}`;
  };

  trackFrontendToolingPerformanceBreakdownTiming(
    name,
    loadType ?? "NULL",
    status,
    format(dataFetched),
    format(lastImageLoadTime),
    format(mainJsExecuted),
    format(mainThreadQuietTime),
    format(pageComponentMounted),
    format(pageComponentRenderedWithData),
    format(pageJsExecuted),
    format(readyToFetchData),
    format(readyToFetchPageJs),
    format(htmlStarted),
    format(upltEndTime),
    `${getGlobalProperty("isNextJS")}`
  );
};
